import { useEffect, useState } from "react";
import client, { imgSrc } from "@/lib/api";
import { MaskedLine, Reveal } from "@/components/Reveal";
import { useTexts } from "@/lib/texts";
import MiniWheel from "@/components/MiniWheel";

export default function Novita() {
  const texts = useTexts();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    client
      .get("/posts")
      .then((r) => setPosts(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <main className="mx-auto max-w-7xl px-5 pb-28 pt-32 md:px-8 md:pt-40" data-testid="novita-page">
      <Reveal>
        <p className="text-[10px] uppercase tracking-[0.4em] text-gold">{texts.novita_kicker}</p>
      </Reveal>
      <MaskedLine className="mt-4 font-serif text-5xl md:text-7xl" delay={0.1}>{texts.novita_title}</MaskedLine>
      <Reveal delay={0.25}>
        <p className="mt-6 max-w-xl text-base leading-relaxed text-[#A3A3A3] md:text-lg">
          {texts.novita_sub}
        </p>
      </Reveal>

      {loading ? (
        <p className="py-24 text-center text-sm uppercase tracking-[0.3em] text-[#737373]" data-testid="novita-loading">Caricamento…</p>
      ) : posts.length === 0 ? (
        <p className="py-24 text-center font-serif text-2xl italic text-[#A3A3A3]" data-testid="novita-empty">
          Nessuna novità al momento. Torna presto a trovarci.
        </p>
      ) : (
        <div className="mt-16 space-y-20">
          {posts.map((post, i) => (
            <article
              key={post.id}
              data-testid={`post-card-${post.id}`}
              className={`grid items-center gap-10 lg:grid-cols-12 ${i % 2 === 1 ? "" : ""}`}
            >
              {post.link === "/promo" ? (
                <Reveal className={`lg:col-span-5 ${i % 2 === 1 ? "lg:order-2" : ""}`}>
                  <a href="/promo" aria-label="Vai alla Promo" data-testid={`post-card-${post.id}-wheel`}>
                    <MiniWheel />
                  </a>
                </Reveal>
              ) : (
                post.image && (
                  <Reveal className={`lg:col-span-5 ${i % 2 === 1 ? "lg:order-2" : ""}`}>
                    <div className="relative overflow-hidden bg-[#0a0a0a] p-2.5">
                      <img
                        src={imgSrc(post.image)}
                        alt={post.title}
                        loading="lazy"
                        className={`aspect-[4/3] w-full object-cover ${/ciondolo/i.test(post.image) ? "pendant-sway" : ""}`}
                      />

                      {/natale/i.test(post.title) && (
                        <div className="absolute inset-0" aria-hidden="true" data-testid={`post-card-${post.id}-snow`}>
                          <div className="snow-layer snow-a" />
                          <div className="snow-layer snow-b" />
                          <div className="snow-layer snow-c" />
                        </div>
                      )}
                    </div>
                  </Reveal>
                )
              )}
              <div className={`${post.image || post.link === "/promo" ? "lg:col-span-7" : "lg:col-span-12"} ${i % 2 === 1 && (post.image || post.link === "/promo") ? "lg:order-1" : ""}`}>
                <Reveal>
                  <p className="text-[10px] uppercase tracking-[0.35em] text-gold">
                    <span className="outline-number font-serif text-4xl normal-case tracking-normal">{String(i + 1).padStart(2, "0")}</span>
                  </p>
                </Reveal>
                {post.link === "/promo" ? (
                  <>
                    <MaskedLine className="mt-4 font-serif text-3xl md:text-4xl" delay={0.1}>Tenta la fortuna:</MaskedLine>
                    <MaskedLine className="font-serif text-3xl md:text-4xl" delay={0.2}>ogni giorno un premio fino a Natale</MaskedLine>
                  </>
                ) : (
                  <MaskedLine className="mt-4 font-serif text-3xl md:text-4xl" delay={0.1}>{post.title}</MaskedLine>
                )}
                {post.excerpt && (
                  <Reveal delay={0.2}>
                    <p className="mt-4 font-serif text-lg italic text-gold-pale/90">{post.excerpt}</p>
                  </Reveal>
                )}
                <Reveal delay={0.3}>
                  <p className="mt-4 max-w-2xl text-base leading-relaxed text-[#A3A3A3]">{post.content}</p>
                </Reveal>
                {post.link && (
                  <Reveal delay={0.35}>
                    <a
                      href={post.link}
                      data-testid={`post-card-${post.id}-cta`}
                      className="mt-6 inline-flex items-center gap-2 bg-gold px-6 py-3 text-[10px] font-semibold uppercase tracking-[0.25em] text-black transition-all duration-300 hover:-translate-y-0.5 hover:bg-gold-hover"
                    >
                      {post.link_label || "Scopri di più"}
                    </a>
                  </Reveal>
                )}
              </div>
            </article>
          ))}
        </div>
      )}
    </main>
  );
}
